import BigNumber from 'bignumber.js'
import { usePriceVvsUsdc } from 'state/farms/hooks'
import useXvvsRate from './useXvvsRate'

const usePriceXvvsUsdc: () => BigNumber = () => {
  const vvsPriceUsd = usePriceVvsUsdc()
  const rate = useXvvsRate()

  return vvsPriceUsd.times(rate.toSignificant(18))
}

export default usePriceXvvsUsdc
